module.exports = function(value) {
  return value && value.items
    ? value.items.map(i => `(${i.count}) ${i.name}`.trim()).join(', ')
    : '';
};
